
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["scatter-demo-common","scatter-demo-markdown","scatter-demo-group"],
  getter: () => import(/* webpackChunkName: "meta__Scatter__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.en.md?type=demo')
};